import React from 'react';
import { ThemeConsumer } from 'styled-components';

const Bicycle: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <ThemeConsumer>
      {(theme) => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="122"
          height="94"
          fill="none"
          viewBox="0 0 122 94"
        >
          <path
            fill={theme.primary[50]}
            d="M74.622 0H47.467C30.088 0 16 14.07 16 31.424V62.12c0 17.355 14.088 31.424 31.467 31.424h27.155c17.379 0 31.467-14.069 31.467-31.424V31.425C106.089 14.068 92.001 0 74.622 0z"
          ></path>
          <path
            stroke={theme.primary[100]}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M1 80.769h120"
          ></path>
          <path
            fill={theme.primary[500]}
            d="M46.78 29.59h2.774c.432 0 .795-.35.795-.795a.796.796 0 00-.794-.795H46.78a.796.796 0 00-.795.795.805.805 0 00.795.794zM49.447 37.739l3.879-8.15h4.66c.431 0 .795-.35.795-.794a.796.796 0 00-.794-.795H52.76a.17.17 0 00-.08.014c-.027 0-.054.013-.068.013-.027.013-.054.013-.067.027-.027.013-.054.027-.068.027-.026.013-.04.027-.067.04-.027.014-.04.027-.067.04a.106.106 0 00-.054.054l-.054.054c-.014.014-.027.04-.054.054l-.04.081c-.014.014-.014.027-.027.04l-6.627 13.942a11.908 11.908 0 00-4.445-.85C34.402 41.537 29 46.939 29 53.58c0 6.64 5.401 12.041 12.042 12.041 6.64 0 12.041-5.4 12.041-12.041 0-3.381-1.427-6.614-3.92-8.904a.79.79 0 00-1.117.054.79.79 0 00.054 1.118 10.485 10.485 0 013.408 7.732c0 5.765-4.701 10.465-10.466 10.465s-10.466-4.7-10.466-10.465 4.7-10.466 10.466-10.466c1.306 0 2.572.242 3.771.7L43.75 46.05l-3.421 7.193a.792.792 0 00.377 1.05.785.785 0 001.05-.364l3.058-6.438a7.197 7.197 0 013.395 6.089c0 3.946-3.22 7.165-7.166 7.165-3.947 0-7.166-3.219-7.166-7.165 0-3.96 3.22-7.166 7.166-7.166a.796.796 0 000-1.59c-4.822 0-8.755 3.92-8.755 8.756 0 4.822 3.92 8.741 8.755 8.741 4.822 0 8.741-3.92 8.741-8.741a8.776 8.776 0 00-4.296-7.53l3.206-6.748 9.038 11.3c.161.19.39.297.62.297a.79.79 0 00.62-1.28l-9.524-11.88z"
          ></path>
          <path
            fill={theme.primary[500]}
            d="M81.572 41.55c-2.263 0-4.432.62-6.331 1.805l-5.496-7.718a.816.816 0 00-.646-.337H52.774a.796.796 0 00-.795.795c0 .431.35.795.795.795H68.68l7.193 10.075a8.952 8.952 0 00-2.37 3.233.786.786 0 00.417 1.037c.094.04.202.067.31.067a.77.77 0 00.727-.485 7.21 7.21 0 011.832-2.559l3.246 4.553h-8.903c.148-2.061.902-4 2.182-5.644a.79.79 0 00-.135-1.105.79.79 0 00-1.104.135 11.835 11.835 0 00-2.52 6.627h-7.219l6.034-13.227a.81.81 0 00-.39-1.05.81.81 0 00-1.05.39l-6.547 14.345a.792.792 0 00.714 1.118h11.745c.404 4.459 4.149 7.96 8.715 7.96 4.822 0 8.755-3.919 8.755-8.741 0-4.822-3.92-8.755-8.755-8.755-.471 0-.93.04-1.387.107a.791.791 0 00.242 1.563 8.035 8.035 0 011.145-.094c3.947 0 7.166 3.219 7.166 7.165 0 3.947-3.22 7.166-7.166 7.166-3.69 0-6.735-2.802-7.125-6.384h7.125a.777.777 0 00.7-.431.816.816 0 00-.053-.822l-6.062-8.5a10.45 10.45 0 015.415-1.508c5.765 0 10.466 4.701 10.466 10.466s-4.7 10.466-10.466 10.466c-4.62 0-8.755-3.098-10.048-7.53a.797.797 0 00-.983-.538.797.797 0 00-.54.983c1.482 5.105 6.25 8.66 11.571 8.66 6.64 0 12.042-5.4 12.042-12.041.013-6.64-5.388-12.042-12.028-12.042zM64.075 31.53c.714.255 2.128.78 3.596 1.535.216.121 1.94 1.037 4.378 1.037a9.65 9.65 0 001.603-.135 4.857 4.857 0 003.192-2.02l.04-.054a2.47 2.47 0 00.135-2.546 2.495 2.495 0 00-2.223-1.333H64.681c-.997 0-1.805.808-1.805 1.805a1.82 1.82 0 001.199 1.71zm.606-1.94h10.115c.35 0 .66.188.822.498a.88.88 0 01-.04.93l-.027.04a3.312 3.312 0 01-2.155 1.36c-2.802.472-4.93-.714-4.944-.727-.013 0-.027-.014-.04-.014a30.09 30.09 0 00-3.799-1.63c-.094-.026-.148-.12-.148-.215a.22.22 0 01.216-.242z"
          ></path>
          <rect
            width="2"
            height="8"
            x="36"
            y="21"
            fill={theme.primary[500]}
            rx="1"
          ></rect>
          <rect
            width="2"
            height="8"
            x="33"
            y="26"
            fill={theme.primary[500]}
            rx="1"
            transform="rotate(-90 33 26)"
          ></rect>
          <rect
            width="1.707"
            height="6.828"
            x="54.639"
            y="68.811"
            fill={theme.primary[500]}
            rx="0.854"
            transform="rotate(45 54.639 68.81)"
          ></rect>
          <rect
            width="1.707"
            height="6.828"
            x="49.81"
            y="70.018"
            fill={theme.primary[500]}
            rx="0.854"
            transform="rotate(-45 49.81 70.018)"
          ></rect>
          <rect
            width="1.707"
            height="6.828"
            x="92.639"
            y="19.811"
            fill={theme.primary[500]}
            rx="0.854"
            transform="rotate(45 92.639 19.81)"
          ></rect>
          <rect
            width="1.707"
            height="6.828"
            x="87.811"
            y="21.018"
            fill={theme.primary[500]}
            rx="0.854"
            transform="rotate(-45 87.81 21.018)"
          ></rect>
          <circle
            cx="93.5"
            cy="68.5"
            r="2.5"
            fill={theme.primary[500]}
          ></circle>
          <circle cx="24" cy="62" r="2" fill={theme.primary[500]}></circle>
          <circle
            cx="67.5"
            cy="15.5"
            r="1.5"
            fill={theme.primary[500]}
          ></circle>
        </svg>
      )}
    </ThemeConsumer>
  );
};

export default Bicycle;
